import { IWidgetWithFormData, IBlogSubscribeWidgetData } from "@pageBuilder/typings";
import { FormFieldRenderer } from "../form-field-renderer";
import { SubscribeScriptRenderer } from "./subscribe-script.renderer";
import { FormWidgetBaseRenderer } from "../form-widget-base-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";
import { FormReCaptchaScriptRenderer } from "../form-recaptcha-script.renderer";
import { FormTruCaptchaScriptRenderer } from "../form-trucaptcha-script.renderer";

export class BlogSubscribeWidgetRenderer extends FormWidgetBaseRenderer {

    private readonly recaptchaScriptRenderer: FormReCaptchaScriptRenderer;
    private readonly trucaptchaScriptRenderer: FormTruCaptchaScriptRenderer;
    private readonly widgetScriptRenderer: SubscribeScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);

        this.recaptchaScriptRenderer = new FormReCaptchaScriptRenderer();
        this.trucaptchaScriptRenderer = new FormTruCaptchaScriptRenderer();
        this.widgetScriptRenderer = new SubscribeScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("subscribeWidget");
    }

    protected override createForm(): HTMLFormElement {
        const form = super.createBaseForm();
        form.action = "/blog-subscribe-endpoint";
        return form;
    }

    protected override renderFormWidgetInternal(element: HTMLElement, data: IWidgetWithFormData): HTMLElement {
        const modifiedElement = super.renderBaseInternal(element, data);
        modifiedElement.setAttribute("data-subscription", "blog");

        element.removeAttribute("data-gdpr-enabled");
        if (this.renderingCommonContext.data.gdprInfo.isGdprEnabled) {
            element.setAttribute("data-gdpr-enabled", "");
            const form = element.querySelector<HTMLFormElement>("form");
            if (form) {
                form.style.setProperty("--fields-number", (data.fields.length + 1).toString());
            }
        }

        this.cleanupScripts();
        if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "TruCaptcha") {
            this.trucaptchaScriptRenderer.renderCommon(this.renderedDocument);
        } else if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "ReCaptcha"){
            this.recaptchaScriptRenderer.renderCommon(this.renderedDocument);
        }

        this.widgetScriptRenderer.renderCommon(this.renderedDocument);
        this.widgetScriptRenderer.renderLocal(element);

        this.renderStyles(element, data);

        return modifiedElement;
    }

    protected override setFormData(form: HTMLFormElement, data: IWidgetWithFormData): void {
        super.setBaseFormData(form, data);
        const subscribeData = data as IBlogSubscribeWidgetData;
        FormFieldRenderer.ensureHidden(form, "blogId", subscribeData?.blogId ?? "");
    }

    private cleanupScripts(): void {
        this.trucaptchaScriptRenderer.cleanupCommon(this.renderedDocument);
        this.recaptchaScriptRenderer.cleanupCommon(this.renderedDocument);
    }

}
